import MuiTableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

import { Column } from '.'

interface Props<T> {
  columns: Column<T>[]
}
const TableHead = <T,>({ columns }: Props<T>) => {
  return (
    <MuiTableHead>
      <TableRow>
        {/* <TableCell align="left">No</TableCell> */}
        {columns.map((column) => (
          <TableCell
            align="center"
            style={{ minWidth: column.width ?? 100 }}
            key={column.id as string}
          >
            {column.label}
          </TableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  )
}

export default TableHead
